export const SAFE_SUPPLY_IV_CODE_COUNT_EVENT = 'oatrx:safe-supply-iv-code-review:count';
export const SAFE_SUPPLY_IV_CODE_OPEN_EVENT = 'oatrx:safe-supply-iv-code-review:open';
